import { useMutation } from '@tanstack/react-query';
import { errorHandler } from '@app/utils/errorHandler';
import { api } from '@app/utils/api';
import { PANEl_BASE_URL } from '@app/contstants/endpoints';
import { ManagerMonthlyPlanDto } from '../types';

type Params = {
  managerId: number;
  year: number;
  month: number;
  plan: string;
};

const updateManagerMonthlyPlan = async ({ managerId, year, month, plan }: Params) => {
  const { data } = await api.post<ManagerMonthlyPlanDto>(
    `${PANEl_BASE_URL}/general/manager-plan-month/create_by_params/`,
    {
      manager: managerId,
      year,
      month,
      plan,
    }
  );

  return data;
};

export const useUpdateManagerMonthlyPlan = () => {
  const { mutateAsync, isError, isPending, isSuccess, error } = useMutation({
    mutationFn: updateManagerMonthlyPlan,
    onError: error => errorHandler(error),
  });

  return {
    fetch: mutateAsync,
    isError,
    isPending,
    isSuccess,
    error,
  };
};